import type { TutorBillingFieldRow, TutorBillingRecordChip, TutorBillingRow } from '../model/interfaces'

import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import dayjs from 'dayjs'

export const TUTOR_BILLING_EMPTY_VALUE = '—'

const toValue = (value: string | null | undefined): string => value || TUTOR_BILLING_EMPTY_VALUE

export const getTutorBillingTutorName = (row: TutorBillingRow): string =>
  `${row.tutor.first_name} ${row.tutor.last_name}`.trim()

export const buildTutorBillingRecordChips = (ids: number[], rows: TutorBillingRow[]): TutorBillingRecordChip[] =>
  ids.map((id) => {
    const row = rows.find(item => item.id === id)

    return { id, name: row ? getTutorBillingTutorName(row) : null }
  })

export const formatTutorBillingDate = (value: string): string => dayjs(value).format(DateFormat.KanbanDate)

export const joinTutorBillingMeta = (parts: (string | null)[]): string | null =>
  parts.filter(Boolean).join(' · ') || null

export const buildTutorBillingFields = (
  row: TutorBillingRow,
  getPaymentServiceLabel: (value: string | null) => string,
): TutorBillingFieldRow[] => [
  { key: 'id', label: 'ID', value: String(row.id) },
  { key: 'tutor', label: 'Tutor', value: toValue(getTutorBillingTutorName(row)) },
  { key: 'email', label: 'Email', value: toValue(row.tutor.email) },
  { key: 'account_holder_name', label: 'Account owner name', value: toValue(row.payment.account_holder_name) },
  { key: 'company', label: 'Company', value: toValue(row.payment.account_holder_name) },
  { key: 'company_address', label: 'Company address', value: toValue(row.personal.address_of_living) },
  { key: 'account', label: 'Account number / Email', value: toValue(row.payment.account) },
  { key: 'payment_service', label: 'Payment service', value: getPaymentServiceLabel(row.payment.payment_service) },
  { key: 'country', label: 'Country', value: toValue(row.personal.nationality) },
  { key: 'reference_number', label: 'Beneficiary reference', value: toValue(row.personal.reference_number) },
]
